// src/browser.ts
/**
* One language's interface strings, loaded when that language is used. Browser apps import this entry
* instead of `messages`, so each language becomes its own file in the app build and a page downloads only
* the language it shows, not all five.
*/
async function loadLocaleMessages(locale) {
	switch (locale) {
		case "en": return (await import("./en-XVTTz3qF.mjs").then((n) => n.n)).en;
		case "de": return (await import("./de-DNXNMQG0.mjs").then((n) => n.n)).de;
		case "es": return (await import("./es-BVXrg7ZO.mjs").then((n) => n.n)).es;
		case "fr": return (await import("./fr-CKAHa4O8.mjs").then((n) => n.n)).fr;
		case "tr": return (await import("./tr-BInLzto3.mjs").then((n) => n.n)).tr;
	}
}
export { loadLocaleMessages };

//# sourceMappingURL=browser.mjs.map